<div class="container-fluid p-3 my-2">
    <div class="login-container">
        <div class="d-flex justify-content-center align-items-center" style="height: 75vh;">
            @if (viewState === 'loading') {
                <div class="text-center">
                    <div class="spinner-grow text-primary loading-spinner" role="status">
                        <span class="visually-hidden">Signing you in...</span>
                    </div>
                    <div class="mt-3 text-muted">Signing you in...</div>
                </div>
            } @else if (viewState === 'error') {
                <div class="card shadow-lg" style="width: 70%;">
                    <div class="text-center border-bottom">
                        <img src="logo-blue.svg" alt="Megabus" class="m-2" height="28" />
                    </div>
                    <div class="card-body text-center p-5" role="alert">
                        <h4 class="mb-3">Sign-in failed</h4>
                        <p class="text-muted mb-0">{{ autoLoginErrorMessage }}</p>
                    </div>
                </div>
            } @else {
                <div class="card shadow-lg" style="width: 70%;">
                    <div class="row p-2">
                        <div class="col border-end p-0">
                            <div class="text-center border-bottom">
                                <img id="footer-logo" src="logo-blue.svg" alt="Megabus" class="m-2" height="28" />
                            </div>
                            <div class="card-body">
                                <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                                    <div class="mb-3">
                                        <label for="username" class="form-label">Username</label>
                                        <input
                                            type="email"
                                            class="form-control"
                                            id="username"
                                            formControlName="username"
                                            placeholder="Enter your username or email"
                                            aria-describedby="emailHelp"
                                            autocomplete="off"
                                        />
                                        <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="password" class="form-label">Password</label>
                                        <input
                                            type="password"
                                            class="form-control"
                                            id="password"
                                            formControlName="password"
                                            placeholder="Enter your password"
                                        />
                                    </div>
                                    <div class="mb-3">
                                        <label for="base_url" class="form-label">Server Url</label>
                                        <input
                                            type="url"
                                            class="form-control"
                                            id="base_url"
                                            formControlName="base_url"
                                            placeholder="Enter your server url"
                                            autocomplete="off"
                                        />
                                        <div id="emailHelp" class="form-text">You can get this url from the Marlin Desktop App.</div>
                                    </div>

                                    <button type="submit" [disabled]="!formGroup.valid" class="btn btn-primary w-100">Login</button>

                                    @if (staffSignInEnabled && staffSignInRequested()) {
                                        <div class="text-center text-muted mb-3" aria-hidden="true">or</div>
                                        <button
                                            type="button"
                                            class="btn btn-outline-primary w-100"
                                            [disabled]="entraPending()"
                                            [attr.aria-busy]="entraPending()"
                                            (click)="signInWithEntra()"
                                        >
                                            Sign in with Microsoft
                                        </button>
                                    }
                                </form>
                            </div>
                        </div>
                        <div class="col p-0 d-none d-lg-block">
                            <div class="text-center border-bottom">
                                <img id="header-logo" alt="Megabus" src="logo-blue.svg" class="m-2" height="28" />
                            </div>
                            <div class="card-body" style="height: 80%;">
                                <lib-system-announcements-widget />
                            </div>
                            <div class="align-items-end p-2">
                                <span class="text-muted">Version 1.0.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
